import Complaints from './complaintsContainer';

export default Complaints;
